import { Injectable } from '@angular/core';
import {Headers, Http} from '@angular/http';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {DropDownFieldOption} from '../../interfaces/DropDownFieldOption';

@Injectable()
export class FieldOptionService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private fieldOptionUrl = 'fieldoption';

    constructor(private http: AuthHttp) { }



    public getList(parentId: number) {
        const url = `${environment.baseUrl}${this.fieldOptionUrl}/${parentId}`;
        return this.http
            .get(url,  {headers: this.headers})
            .toPromise()
            .then(response => {
                return response.json() as DropDownFieldOption[];
            })
            .catch(this.handleError);
    }
    public create(parentId: number, name: string) {
        const url = `${environment.baseUrl}${this.fieldOptionUrl}/${parentId}`;
        return this.http
            .post(url, {'name': name}, {headers: this.headers})
            .toPromise()
            .then(response => {
                return response.json() as DropDownFieldOption[];
            })
            .catch(this.handleError);
    }
    public update(updatedItem) { // This method might not be needed in the end
        const url = `${environment.baseUrl}${this.fieldOptionUrl}/${updatedItem.field_id}`;
        return this.http
            .put(url, JSON.stringify(updatedItem), {headers: this.headers})
            .toPromise()
            .then(response => {
                return response.json() as DropDownFieldOption;
            })
            .catch(this.handleError);
    }
    public delete(id: number): Promise<void> {
        const url = `${environment.baseUrl}${this.fieldOptionUrl}/${id}`;
        return this.http
            .delete(url, {headers: this.headers})
            .toPromise()
            .then(() => null)
            .catch(this.handleError);
    }
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/services/field-option/field-option.service.ts